import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import tw, { styled } from 'twin.macro';
import PropTypes from 'prop-types';

import { selectFormCalculations } from '../../../builder/selectors/calculation';
import { FormContext } from '../../../customise/contexts/form-context';
import { ControlType } from '../../../../shared/form-lib';
import { ControlPropType } from '../../ctrl_proptype';

const SpecialProps = styled.div`
  ${tw`m-0 p-0 z-10 flex gap-1 max-w-max bg-transparent`};

  span {
    ${tw`px-2 py-0.5 text-sm rounded`}

    font-family: 'Inter' !important;

    &.lookup {
      background-color: #ecf0ff;
    }

    &.read-only {
      background-color: #e5fceb;
    }

    &.calc-result {
      background-color: #fff8e7;
    }

    &.hidden {
      background-color: #ecfbff;
    }
  }
`;

const SpecialPropsIndicators = ({ ctrl }) => {
  const {
    internal_id,
    props: { form, hidden, readonly, form_field, lookup_type, dest_field_ids, source_field_ids },
  } = ctrl;
  const { inBuilder } = useContext(FormContext);
  const isLookup = ctrl.type === ControlType.LOOKUP;
  const calculations = useSelector(selectFormCalculations);
  const isCalcResult = calculations.some((calc) => calc.result === internal_id);
  const isIncompletelySetup =
    isLookup &&
    (!form ||
      !form_field ||
      (lookup_type == 1 &&
        (!source_field_ids.length ||
          !dest_field_ids.length ||
          source_field_ids[0].indexOf('init') === 0 ||
          dest_field_ids[0].indexOf('init') === 0)));

  if (!inBuilder) return null;

  return (
    <SpecialProps>
      {isLookup && <span className="lookup">{isIncompletelySetup ? 'Lookup setup is incomplete' : 'Lookup'}</span>}
      {readonly && <span className="read-only">Read only</span>}
      {isCalcResult && <span className="calc-result">Calc. result</span>}
      {hidden && <span className="hidden">Hidden</span>}
    </SpecialProps>
  );
};

SpecialPropsIndicators.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
};

export default SpecialPropsIndicators;
